var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"login-error-container logged-out-container p-d-flex p-flex-column p-jc-center p-ai-center"},[_c('h3',[_vm._v("The email and password you entered do not match our records. Please double-check and try again.")])])
}]

export { render, staticRenderFns }